import {Grid, Box} from '@jobseeker/lotus/foundations';
import {useWrappedTheme} from '@jobseeker/lotus/hooks';
import {Link} from './styles';
import {Typography} from '@mui/material';

import type {Props} from './types';
import {useSelector} from 'react-redux';
import {AppState} from '@jobseeker/common-core/types';

const BaseFooter = (props: Props) => {
  const theme = useWrappedTheme();
  const {
    timelines: {
      config: {competitionName},
    },
  } = useSelector((state: AppState) => state.competition);
  return (
    <Box
      display="flex"
      alignItems={'center'}
      justifyContent={'center'}
      sx={{
        backgroundColor: props.bgcolor || 'secondary.main',
      }}
    >
      <Grid
        container
        sx={{
          justifyContent: 'center',
          backgroundColor: props.bgcolor || 'secondary.main',
          display: 'flex',
          maxWidth: 1440,
          width: '100%',
          alignItems: 'center',
          paddingLeft: {sm: theme.spacing(2), xxl: theme.spacing(0)},
          paddingRight: {sm: theme.spacing(2), xxl: theme.spacing(0)},
        }}
      >
        <Grid
          item
          sx={{
            mt: theme.spacing(2),
            mb: theme.spacing(2),
            p: 1,
            justifyContent: 'center',
            textAlign: 'center',
            fontSize: theme.typography.pxToRem(14),
            color: '#fff',
            alignContent: 'center',
            paddingLeft: {
              sm: theme.spacing(3.5),
              md: '0px',
            },
          }}
        >
          <Box display={'flex'} justifyContent={'center'}>
            {props.socialLinks?.map((sl, index) => (
              <Link
                isButton={sl.isButton}
                href={sl.url}
                elIndex={index}
                target="_blank"
                key={`sociallink-footer-${index}`}
                aria-label={sl.label}
              >
                {sl.icon}
              </Link>
            ))}
          </Box>
          <Box mt={1}>
            {props.headerLabel?.replace(
              '{{year}}',
              new Date().getFullYear().toString()
            )}
          </Box>
          <Box mt={1}>
            <Typography
              component={'a'}
              variant="body2"
              href={props?.termsLink ? '/terms' : `/${competitionName}/terms`}
              target="_blank"
              sx={{
                textDecoration: 'none',
                color: '#ffffff',
                cursor: 'pointer',
              }}
            >
              Terms & Conditions
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BaseFooter;
